import collage from "../../../config/collageStyle";
import wallDisplay from "../../../config/wallDisplayStyle";
import foamTile from "../../../config/foamTileStyle";
import photos from "../../../config/photosStyle";

{
  /*
  Fabric Builder Product Values

  Use productType as key

  h & w are hardcoded in pixels for what looks best in the full 610w x 475h player div
  Make sure to keep aspect ratio of the product's print area
  These values dictate the size of the print area mask and get updated by
  the size selector if applicable

  defaultH & defaultW are used to create new h & w values when the size ratio of the
  product is changed. This is triggered by the size selector, if the product does not
  change size these are not needed

  canH & canW are the print area dimensions in inches if they are not in the product title
  If they are included in the product title do not add them here

  Mask color is the bgcolor of the print area on the model
  This is also based on what looks best, most use #f4f4f4
*/
}

const productValues = {
  ornament: {
    maskColor: "#f4f4f4",
    canWidth: 3,
    canHeight: 3.5,
    masks: {
      ornament_1: {
        width: 175,
        height: 175,
        left: 0,
        top: 0,
      },
      ornament_2: {
        width: 175,
        height: 175,
        left: 210,
        top: 0,
      },
      ornament_3: {
        width: 175,
        height: 175,
        left: 0,
        top: 220,
      },
      ornament_4: {
        width: 175,
        height: 175,
        left: 210,
        top: 220,
      },
    },
  },
  plaque: {
    width: 300 * (8 / 10),
    height: 300,
    defaultWidth: 300,
    defaultHeight: 300,
    maskColor: "#f4f4f4",
  },
  poster: {
    width: 360,
    height: 320,
    defaultWidth: 360,
    defaultHeight: 320,
    maskColor: "#f4f4f4",
    config: {
      recommendedSize: true,
      bleed: true,
      background: true,
      offset: {
        top: -50,
      },
    },
    texture: {
      Glossy: {
        source:
          "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/glossy_poster.png",
        opacity: 0.75,
      },
      "Semi-gloss": {
        source:
          "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/glossy_poster.png",
        opacity: 0.5,
      },
      Matte: {
        source:
          "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/glossy_poster.png",
        opacity: 0,
      },
    },
    XS: {
      defaultWidth: 260,
      defaultHeight: 220,
    },
    S: {
      defaultWidth: 290,
      defaultHeight: 250,
    },
    M: {
      defaultWidth: 330,
      defaultHeight: 290,
    },
    L: {
      defaultWidth: 360,
      defaultHeight: 320,
    },
  },
  metal: {
    width: 360,
    height: 320,
    defaultWidth: 360,
    defaultHeight: 320,
    maskColor: "#dddddd",
    config: {
      dropShadow: "drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.15))",
      background: true,
      offset: {
        top: -50,
      },
    },
    texture: {
      source:
        "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/metal-2.png",
      opacity: 0.5,
    },
    XS: {
      defaultWidth: 260,
      defaultHeight: 220,
    },
    S: {
      defaultWidth: 290,
      defaultHeight: 250,
    },
    M: {
      defaultWidth: 330,
      defaultHeight: 290,
    },
    L: {
      defaultWidth: 360,
      defaultHeight: 320,
    },
  },
  triptych: {
    width: 125,
    height: 250,
    defaultWidth: 125,
    defaultHeight: 250,
    top: 0,
    maskColor: "#f4f4f4",
    config: {
      dropShadow: "drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.15))",
    },
    texture: {
      source:
        "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/canvas_texture.png",
      opacity: 0.5,
    },
  },
  "triptych-flow": {
    width: 125,
    height: 250,
    defaultWidth: 125,
    defaultHeight: 150,
    top: 15,
    maskColor: "#f4f4f4",
    minHeight: 218.75,
    config: {
      dropShadow: "drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.15))",
    },
    texture: {
      source:
        "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/canvas_texture.png",
      opacity: 0.5,
    },
  },
  "single-canvas": {
    width: 360,
    height: 320,
    defaultWidth: 360,
    defaultHeight: 320,
    maskColor: "#f4f4f4",
    config: {
      recommendedSize: true,
      dropShadow: "drop-shadow(8px 10px 8px rgba(0, 0, 0, 0.45))",
      background: true,
      offset: {
        top: -50,
      },
    },
    texture: {
      source:
        "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/canvas_texture.png",
      opacity: 0.5,
    },
    XS: {
      defaultWidth: 260,
      defaultHeight: 220,
    },
    S: {
      defaultWidth: 290,
      defaultHeight: 250,
    },
    M: {
      defaultWidth: 330,
      defaultHeight: 290,
    },
    L: {
      defaultWidth: 360,
      defaultHeight: 320,
    },
  },
  pillow: {
    width: 300,
    height: 280,
    maskColor: "#f4f4f4",
    defaultWidth: 300,
    defaultHeight: 280,
    config: {
      recommendedSize: true,
    },
  },
  magnet: {
    maskColor: "#f4f4f4",
    defaultWidth: 200,
    defaultHeight: 200,
    min: 1,
    max: 500,
    masks: {
      magnet_1: {
        width: 200,
        height: 200,
        left: 0,
        top: 0,
      },
      magnet_2: {
        width: 200,
        height: 200,
        left: 220,
        top: 0,
      },
      magnet_3: {
        width: 200,
        height: 200,
        left: 0,
        top: 220,
      },
      magnet_4: {
        width: 200,
        height: 200,
        left: 220,
        top: 220,
      },
    },
  },
  mousepad: {
    width: 300,
    height: 300 * (11.8 / 31.5),
    defaultWidth: 300,
    defaultHeight: 300 * (11.8 / 31.5),
    maskColor: "#f4f4f4",
  },
  glasscuttingboard: {
    width: 300,
    height: 300 * (11 / 7.8),
    defaultWidth: 300,
    defaultHeight: 280,
    maskColor: "#f4f4f4",
  },
  coaster: {
    maskColor: "#f4f4f4",
    canvasWidth: 3.86,
    canvasHeight: 3.86,
    masks: {
      coaster_1: {
        width: 200,
        height: 200,
        left: 0,
        top: 0,
      },
      coaster_2: {
        width: 200,
        height: 200,
        left: 220,
        top: 0,
      },
      coaster_3: {
        width: 200,
        height: 200,
        left: 0,
        top: 220,
      },
      coaster_4: {
        width: 200,
        height: 200,
        left: 220,
        top: 220,
      },
    },
  },
  "coaster-square": {
    canvasWidth: 3.94,
    canvasHeight: 3.94,
    maskColor: "#f4f4f4",
    masks: {
      coaster_1: {
        width: 200,
        height: 200,
        left: 0,
        top: 0,
      },
      coaster_2: {
        width: 200,
        height: 200,
        left: 220,
        top: 0,
      },
      coaster_3: {
        width: 200,
        height: 200,
        left: 0,
        top: 220,
      },
      coaster_4: {
        width: 200,
        height: 200,
        left: 220,
        top: 220,
      },
    },
  },
  tote: {
    width: 210 * (10.5 / 12.5),
    height: 210,
    maskColor: "#bbb7b7",
    canHeight: 12.5,
    canWidth: 10.5,
    config: {
      background: true,
      offset: {
        top: 90,
      },
    },
  },
  "large-tote": {
    width: 215 * (12 / 13),
    height: 215,
    maskColor: "#f4f4f4",
    canHeight: 13,
    canWidth: 12,
    config: {
      background: true,
      offset: {
        top: 60,
      },
    },
  },
  "small-tote": {
    width: 205 * (10 / 14),
    height: 205,
    maskColor: "#f4f4f4",
    canHeight: 14,
    canWidth: 10,
    config: {
      background: true,
      offset: {
        top: 60,
      },
    },
  },
  mug: {
    width: 280,
    height: 280,
    maskColor: "#f4f4f4",
    canHeight: 3.5,
    canWidth: 3.5,
    texture: {
      source:
        "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/glossy_poster.png",
      opacity: 1,
    },
    config: {
      background: true,
      offset: {
        top: 62,
        left: 27,
        backLeft: -27,
      },
    },
  },
  "camping-mug": {
    width: 280,
    height: 280,
    maskColor: "#f4f4f4",
    canWidth: 3.5,
    canHeight: 2,
    texture: {
      source:
        "https://cdn.shopify.com/s/files/1/0591/4299/6149/files/glossy_poster.png",
      opacity: 1,
    },
    config: {
      background: true,
    },
  },
  tumbler: {
    width: 500,
    height: 500 * (3.75 / 10.5),
    canWidth: 10.5,
    canHeight: 3.75,
    maskColor: "#f4f4f4",
  },
  "koozie-16": {
    maskColor: "#f4f4f4",
    width: 500,
    height: 500 * (7 / 4.4),
    canWidth: 4.4,
    canHeight: 7
  },
  "koozie-12": {
    maskColor: "#f4f4f4",
    width: 300,
    height: 300 * (5.5 / 4),
    canWidth: 4,
    canHeight: 5.5
  },
  "drink-tumbler": {
    width: 500,
    height: 500 * (4 / 11.6),
    canWidth: 11.6,
    canHeight: 4,
    defaultHeight: 500,
    defaultWidth: 500,
    maskColor: "#f4f4f4",
  },
  puzzle: {
    width: 300,
    height: 300 * (7 / 10),
    defaultWidth: 300,
    defaultHeight: 300 * (7 / 10),
    maskColor: "#f4f4f4",
  },
  acrylic: {
    width: 300,
    height: 300 * (11 / 14),
    defaultWidth: 300,
    defaultHeight: 300 * (11 / 14),
    maskColor: "#f4f4f4",
  },
  fleece: {
    width: 375,
    height: 375 * (30 / 40),
    defaultWidth: 375,
    defaultHeight: 375,
    maskColor: "#f4f4f4",
  },
  woven: {
    width: 375 * (37 / 52),
    height: 375,
    defaultWidth: 375,
    defaultHeight: 375,
    maskColor: "#f4f4f4",
  },
  "wall-display": {
    maskColor: "#f4f4f4",
    masks: wallDisplay,
    config: {
      noDimensions: true,
      dropShadow: "drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.15))",
    },
  },
  collage: {
    maskColor: "#f4f4f4",
    masks: collage,
    width: 375,
    height: 375,
    defaultWidth: 375,
    defaultHeight: 375,
    config: {
      dropShadow: "drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.15))",
    },
  },
  sticker: {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360,
    defaultHeight: 360,
    defaultWidth: 360,
  },
  "metal-magnet": {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360,
    defaultHeight: 360,
    defaultWidth: 360,
  },
  "promo-magnet": {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360,
    defaultHeight: 360,
    defaultWidth: 360,
  },
  tile: {
    maskColor: "#f4f4f4",
    width: 140,
    height: 140,
    canWidth: 8,
    canHeight: 8,
    masks: foamTile,
    config: {
      dropShadow: "drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.15))",
    },
  },
  photos: {
    maskColor: "#f4f4f4",
    width: 100,
    height: 100 * (4 / 6),
    defaultWidth: 100,
    defaultHeight: 100,
    masks: photos,
  },
  bottle: {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360 * (1.69 / 5.75),
    canWidth: 5.75,
    canHeight: 1.69,
  },
  "water-bottle": {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360 * (4.25 / 7.7),
    defaultHeight: 360,
    defaultWidth: 360,
  },
  "bottle-opener-poly": {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360 * (1.8 / 4.2),
    defaultHeight: 360,
    defaultWidth: 360,
  },
  "bottle-opener-brushed": {
    maskColor: "#f4f4f4",
    width: 100,
    height: 100 * (1.8 / 7.25),
    canWidth: 7.25,
    canHeight: 1.8,
  },
  "luggage-tag": {
    maskColor: "#f4f4f4",
    width: 300,
    height: 300 * (4 / 2.75),
    canWidth: 2.75,
    canHeight: 4,
  },
  "dog-tag": {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360 * (2.12 / 1.25),
    canWidth: 1.25,
    canHeight: 2.12,
  },
  wood: {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360 * (8 / 10),
    defaultHeight: 360,
    defaultWidth: 360,
  },
  "pulp-square-coaster": {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360 * (4 / 4),
    defaultHeight: 360,
    defaultWidth: 360,
  },
  "pulp-round-coaster": {
    maskColor: "#f4f4f4",
    width: 360,
    height: 360 * (4 / 4),
    defaultHeight: 360,
    defaultWidth: 360,
  },
  "acrylic-block": {
    width: 300,
    height: 300,
    defaultWidth: 300,
    defaultHeight: 300,
    maskColor: "#f4f4f4",
  },
  glass: {
    width: 300,
    height: 300,
    defaultWidth: 300,
    defaultHeight: 300,
    maskColor: "#f4f4f4",
  },
  tshirt: {
    width: 240 * (10 / 12),
    height: 240,
    maskColor: {
      White: "#E4E4E4",
      Black: "#3A4851",
      Ice: "#CCCCCC",
      Red: "#EA302F",
      Navy: "#304573",
      Light: "#9AB8D3",
      Royal: "#4170F7",
      Cornsilk: "#DBD658",
      Irish: "#1FB86E",
    },
    config: {
      offset: {
        top: -18,
        backTop: -18,
      },
    },
    S: {
      width: 240 * (10 / 12),
      height: 240,
      canWidth: 10,
      canHeight: 12,
    },
    M: {
      width: 240 * (14 / 16),
      height: 240,
      canWidth: 14,
      canHeight: 16,
    },
    L: {
      width: 240 * (14 / 16),
      height: 240,
      canWidth: 14,
      canHeight: 16,
    },
    XL: {
      width: 240 * (14 / 16),
      height: 240,
      canWidth: 14,
      canHeight: 16,
    },
    XXL: {
      width: 250 * (16 / 20),
      height: 250,
      canWidth: 16,
      canHeight: 20,
    },
    XXXL: {
      width: 250 * (16 / 20),
      height: 250,
      canWidth: 16,
      canHeight: 20,
    },
  },
  "tshirt-womens": {
    width: 240 * (10 / 12),
    height: 240,
    maskColor: {
      White: "#D8DBDA",
      Black: "#384348",
      Ice: "#CCCCCC",
      Red: "#DC1F19",
      Navy: "#334974",
      Light: "#B2CAE2",
      Royal: "#386CF8",
      Cornsilk: "#DBD658",
      Irish: "#1FB86E",
    },
    config: {
      offset: {
        top: -18,
        backTop: -18,
      },
    },
    S: {
      width: 240 * (10 / 12),
      height: 240,
      canWidth: 10,
      canHeight: 12,
    },
    M: {
      width: 240 * (14 / 16),
      height: 240,
      canWidth: 14,
      canHeight: 16,
    },
    L: {
      width: 240 * (14 / 16),
      height: 240,
      canWidth: 14,
      canHeight: 16,
    },
    XL: {
      width: 240 * (14 / 16),
      height: 240,
      canWidth: 14,
      canHeight: 16,
    },
    XXL: {
      width: 250 * (16 / 20),
      height: 250,
      canWidth: 16,
      canHeight: 20,
    },
    XXXL: {
      width: 250 * (16 / 20),
      height: 250,
      canWidth: 16,
      canHeight: 20,
    },
  },
  "tshirt-youth": {
    width: 250 * (10 / 12),
    height: 250,
    maskColor: {
      White: "#E4E4E4",
      Black: "#3A4851",
      Ice: "#CCCCCC",
      Red: "#EA302F",
      Navy: "#304573",
      Light: "#9AB8D3",
      Royal: "#4170F7",
      Cornsilk: "#DBD658",
      Irish: "#1FB86E",
    },
    config: {
      offset: {
        top: -18,
        backTop: -18,
      },
    },
    S: {
      width: 240 * (10 / 12),
      height: 240,
      canWidth: 10,
      canHeight: 12,
    },
    M: {
      width: 240 * (10 / 12),
      height: 240,
      canWidth: 10,
      canHeight: 12,
    },
    L: {
      width: 240 * (10 / 12),
      height: 240,
      canWidth: 10,
      canHeight: 12,
    },
    XL: {
      width: 240 * (14 / 16),
      height: 240,
      canWidth: 14,
      canHeight: 16,
    },
  },
  crewneck: {
    width: 180 * (10 / 12),
    height: 180,
    maskColor: {
      White: "#E8E7DF",
      Black: "#1E1F23",
      Ash: "#CDCBC6",
      Red: "#CF2334",
      Navy: "#272D40",
      Light: "#A3BED8",
      Royal: "#2359A2",
      Irish: "#0FA468",
      Dark: "#4B4B4F",
    },
    config: {
      background: true,
      offset: {
        top: -33,
        backTop: -33,
      },
    },
    S: {
      width: 180 * (10 / 12),
      height: 180,
      canWidth: 10,
      canHeight: 12,
    },
    M: {
      width: 180 * (14 / 16),
      height: 180,
      canWidth: 14,
      canHeight: 16,
    },
    L: {
      width: 180 * (14 / 16),
      height: 180,
      canWidth: 14,
      canHeight: 16,
    },
    XL: {
      width: 180 * (14 / 16),
      height: 180,
      canWidth: 14,
      canHeight: 16,
    },
    XXL: {
      width: 180 * (16 / 20),
      height: 180,
      canWidth: 16,
      canHeight: 20,
    },
  },
  "crewneck-youth": {
    width: 180 * (10 / 12),
    height: 180,
    maskColor: {
      White: "#E8E7DF",
      Black: "#1E1F23",
      Ash: "#CDCBC6",
      Red: "#CF2334",
      Navy: "#272D40",
      Light: "#A3BED8",
      Royal: "#2359A2",
      Irish: "#0FA468",
      Dark: "#4B4B4F",
    },
    config: {
      background: true,
      offset: {
        top: -33,
        backTop: -33,
      },
    },
    S: {
      width: 180 * (10 / 12),
      height: 180,
      canWidth: 10,
      canHeight: 12,
    },
    M: {
      width: 180 * (10 / 12),
      height: 180,
      canWidth: 10,
      canHeight: 12,
    },
    L: {
      width: 180 * (10 / 12),
      height: 180,
      canWidth: 10,
      canHeight: 12,
    },
    XL: {
      width: 180 * (14 / 16),
      height: 180,
      canWidth: 14,
      canHeight: 16,
    },
  },
  hoodie: {
    width: 150 * (10 / 12),
    height: 150,
    maskColor: {
      White: "#E8E8E8",
      Black: "#1C1C1C",
      Ash: "#D4D3CE",
      Red: "#B12838",
      Navy: "#333645",
      Light: "#9EADC9",
      Royal: "#506FB4",
      Irish: "#449159",
      Dark: "#505357",
    },
    config: {
      background: true,
      offset: {
        top: -20,
        backTop: -5,
      },
    },
    S: {
      width: 150 * (10 / 12),
      height: 150,
      canWidth: 10,
      canHeight: 12,
    },
    M: {
      width: 150 * (14 / 16),
      height: 150,
      canWidth: 14,
      canHeight: 16,
    },
    L: {
      width: 150 * (14 / 16),
      height: 150,
      canWidth: 14,
      canHeight: 16,
    },
    XL: {
      width: 150 * (14 / 16),
      height: 150,
      canWidth: 14,
      canHeight: 16,
    },
    XXL: {
      width: 150 * (16 / 20),
      height: 150,
      canWidth: 16,
      canHeight: 20,
    },
  },
  "hoodie-youth": {
    width: 150 * (10 / 12),
    height: 150,
    maskColor: {
      White: "#E8E8E8",
      Black: "#1C1C1C",
      Ash: "#D4D3CE",
      Red: "#B12838",
      Navy: "#333645",
      Light: "#9EADC9",
      Royal: "#506FB4",
      Irish: "#449159",
      Dark: "#505357",
    },
    config: {
      background: true,
      offset: {
        top: -20,
        backTop: -5,
      },
    },
    S: {
      width: 150 * (10 / 12),
      height: 150,
      canWidth: 10,
      canHeight: 12,
    },
    M: {
      width: 150 * (10 / 12),
      height: 150,
      canWidth: 10,
      canHeight: 12,
    },
    L: {
      width: 150 * (10 / 12),
      height: 150,
      canWidth: 10,
      canHeight: 12,
    },
    XL: {
      width: 150 * (14 / 16),
      height: 150,
      canWidth: 14,
      canHeight: 16,
    },
  },
  polo: {
    width: 120,
    height: 120 * (3 / 5),
    maskColor: {
      White: "#E8E8E6",
      Black: "#1F2123",
      Ash: "#CAC8C3",
      Red: "#C4182C",
      Navy: "#101324",
      Light: "#7894AE",
      Royal: "#275CA5",
      Kelly: "#2A6A4E",
    },
    config: {
      background: true,
      offset: {
        top: -50,
        left: 95,
      },
    },
    S: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    M: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    L: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    XL: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    XXL: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
  },
  "polo-womens": {
    width: 120,
    height: 120 * (3 / 5),
    maskColor: {
      White: "#E8E8E6",
      Black: "#1F2123",
      Ash: "#CAC8C3",
      Red: "#C4182C",
      Navy: "#101324",
      Light: "#7894AE",
      Royal: "#275CA5",
      Kelly: "#2A6A4E",
    },
    config: {
      background: true,
      offset: {
        top: -50,
        left: 95,
      },
    },
    S: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    M: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    L: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    XL: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    XXL: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
  },
  "polo-youth": {
    width: 120,
    height: 120 * (3 / 5),
    maskColor: {
      White: "#E8E8E6",
      Black: "#1F2123",
      Ash: "#CAC8C3",
      Red: "#C4182C",
      Navy: "#101324",
      Light: "#7894AE",
      Royal: "#275CA5",
      Kelly: "#2A6A4E",
    },
    config: {
      background: true,
      offset: {
        top: -50,
        left: 95,
      },
    },
    S: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    M: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    L: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    XL: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
    XXL: {
      width: 120,
      height: 120 * (3 / 5),
      canWidth: 5,
      canHeight: 3,
    },
  },
};
export default productValues;
